module.exports = __webpack_public_path__ + "static/media/ZFL.2b48f0f0.pdf";